// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__ZGUs7 {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background: #fafafa; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__ZGUs7"
};
module.exports = exports;
